export default function Disclaimer() {
  return (
    <section className="w-full px-4 md:px-8 py-10 bg-background-50">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-start gap-4 bg-accent-50 border border-accent-200 rounded-lg p-5 md:p-6">
        <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-alert-line text-xl" />
        </span>
        <div>
          <h2 className="text-base font-bold text-foreground-950">理性吃瓜声明</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-700">
            本页所有人物、事件与数据均为内容示例与网络公开讨论的整理，其中包含大量尚未获得当事人或官方确认的信息，不构成对任何真实个人或机构的事实认定与评价。
            请以官方公告和权威媒体发布为准，不传播未经证实的内容，不进行人身攻击。若涉及权益问题，请通过平台渠道反馈。
          </p>
        </div>
      </div>
    </section>
  );
}